import React from 'react';
import { Box } from '@landr/maestro';
import { FiltersParams } from 'types/params';
import { useSearchController } from 'controllers/SearchController/SearchContext';
import { useSearchModifiers } from 'controllers/SearchController/hooks/useSearchModifiers';
import useAdvancedFilter from '../hooks/useAdvancedFilter';
import FamilyFilters from './FamilyFilters';
import SubFamilyFilters from './SubFamilyFilters';

export const Filters: React.FC<{
    filterType: FiltersParams;
    isMobile?: boolean;
}> = ({ filterType, isMobile }) => {
    const { getFilterState, getFilterResults } = useAdvancedFilter();

    const { addFilter, removeFilter } = useSearchModifiers();
    const { activeTabTotal } = useSearchController();

    return (
        <Box height="100%" position="relative" width="100%">
            <Box
                paddingX={isMobile ? 'sm' : '2xl'}
                width="100%"
                position="relative"
                paddingBottom="140px"
                display="flex"
                flexDirection="column"
            >
                <FamilyFilters
                    filterType={filterType}
                    activeFilters={getFilterState(filterType) ?? []}
                    filters={getFilterResults(filterType) ?? []}
                    totalNumberOfResults={activeTabTotal ?? 0}
                    addFilter={addFilter}
                    removeFilter={removeFilter}
                />
                <SubFamilyFilters
                    filterType={filterType}
                    activeFilters={getFilterState(filterType) ?? []}
                    filters={getFilterResults(filterType) ?? []}
                    totalNumberOfResults={activeTabTotal ?? 0}
                    addFilter={addFilter}
                    removeFilter={removeFilter}
                />
            </Box>
        </Box>
    );
};

export default Filters;
